import script from "./Comments.vue?vue&type=script&setup=true&lang=ts"
export * from "./Comments.vue?vue&type=script&setup=true&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=2a7c097a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7c097a"]])

export default __exports__